const getContentType = (response) => {
  const headers = response?.headers;
  return headers?.get?.("content-type") || headers?.["content-type"] || "";
};

const parseJSONBlob = async (value) => {
  if (typeof Blob === "undefined" || !(value instanceof Blob)) return null;

  try {
    return JSON.parse(await value.text());
  } catch (_error) {
    return null;
  }
};

export const throwIfBlobContainsAPIData = async (response) => {
  const contentType = getContentType(response) || response?.data?.type || "";
  if (!contentType.toLowerCase().includes("json")) return response;

  const apiData = await parseJSONBlob(response?.data);
  if (!apiData) return response;

  const error = new Error(
    apiData.messageCode || "API returned JSON instead of a file",
  );
  error.response = { ...response, data: apiData };
  throw error;
};

export const normalizeBlobAPIError = async (error) => {
  const apiData = await parseJSONBlob(error?.response?.data);
  if (apiData) {
    error.response = { ...error.response, data: apiData };
  }
  return error;
};
